module.exports = __webpack_public_path__ + "img/YM-YD.538f4123.png";